import { User } from '../../models/User'
import React from 'react'
import { getUserDisplayName } from '../../apps/professional-app/fa/common/aifeatures/utils'
import { parseMetadata } from '../../apps/professional-app/fa/MeetingSummary/utils'
import { Tooltip } from '../../components/Tooltip/Tooltip'

export interface ContactDisplayLabelProps {
  contact: User
}

export const ContactDisplayLabel: React.FC<ContactDisplayLabelProps> = ({ contact }) => {
  const metadata = parseMetadata(contact.metadata ?? '')

  const getTypeIcon = (type: string) => {
    switch (type) {
      case 'Household':
        return (
          <Tooltip className='paragraph-small' title={type} placement='top' offset={[0, 10]}>
            <i className='bi bi-houses' />
          </Tooltip>
        )
      case 'Person':
      case 'Individual':
      case 'Client':
        return (
          <Tooltip className='paragraph-small' title={type} placement='top' offset={[0, 10]}>
            <i className='bi bi-person' />
          </Tooltip>
        )
      case 'Contact':
        return (
          <Tooltip className='paragraph-small' title={type} placement='top' offset={[0, 10]}>
            <i className='bi bi-person-fill' />
          </Tooltip>
        )
      case 'Lead':
        return (
          <Tooltip className='paragraph-small' title={type} placement='top' offset={[0, 10]}>
            <i className='bi bi-person-plus' />
          </Tooltip>
        )
      case 'Company':
      case 'Organization':
      case 'Business':
      case 'Union':
      case 'Association':
        return (
          <Tooltip className='paragraph-small' title={type} placement='top' offset={[0, 10]}>
            <i className='bi bi-building' />
          </Tooltip>
        )
      case 'Trust':
      case 'Opportunity':
        return (
          <Tooltip className='paragraph-small' title={type} placement='top' offset={[0, 10]}>
            <i className='bi bi-award' />
          </Tooltip>
        )
    }
  }

  return (
    <div className='d-flex gap-2'>
      {getUserDisplayName(contact)}
      {getTypeIcon(metadata.type)}
      {contact.email ? ` (${contact.email})` : ''}
    </div>
  )
}
